// Track used images for the current game session
let usedImagesInCurrentGame = new Set();

export const resetGameSession = () => {
  usedImagesInCurrentGame.clear();
};

export const imageDatabase = {
  animals: {
    name: "Animals",
    icon: "🦁",
    images: [
      {
        url: "https://images.pexels.com/photos/247502/pexels-photo-247502.jpeg",
        answer: "lion",
        alternateAnswers: ["male lion"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/145939/pexels-photo-145939.jpeg",
        answer: "tiger",
        alternateAnswers: ["bengal tiger"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/133394/pexels-photo-133394.jpeg",
        answer: "elephant",
        alternateAnswers: ["african elephant"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/635499/pexels-photo-635499.jpeg",
        answer: "giraffe",
        alternateAnswers: ["african giraffe"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/52509/penguins-emperor-antarctic-life-52509.jpeg",
        answer: "penguin",
        alternateAnswers: ["emperor penguin"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/750539/pexels-photo-750539.jpeg",
        answer: "zebra",
        alternateAnswers: ["african zebra"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2657973/pexels-photo-2657973.jpeg",
        answer: "gorilla",
        alternateAnswers: ["silverback gorilla"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1321794/pexels-photo-1321794.jpeg",
        answer: "kangaroo",
        alternateAnswers: ["australian kangaroo"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  food: {
    name: "Food",
    icon: "🍕",
    images: [
      {
        url: "https://images.pexels.com/photos/1146760/pexels-photo-1146760.jpeg",
        answer: "pizza",
        alternateAnswers: ["cheese pizza"],
        photographer: "Kristina Paukshtite",
        photographerUrl: "https://www.pexels.com/@kpauko"
      },
      {
        url: "https://images.pexels.com/photos/1639557/pexels-photo-1639557.jpeg",
        answer: "burger",
        alternateAnswers: ["hamburger"],
        photographer: "Valeria Boltneva",
        photographerUrl: "https://www.pexels.com/@valeriya"
      },
      {
        url: "https://images.pexels.com/photos/357756/pexels-photo-357756.jpeg",
        answer: "sushi",
        alternateAnswers: ["sushi roll"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/291528/pexels-photo-291528.jpeg",
        answer: "cake",
        alternateAnswers: ["chocolate cake"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1352281/pexels-photo-1352281.jpeg",
        answer: "ice cream",
        alternateAnswers: ["sundae"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1437267/pexels-photo-1437267.jpeg",
        answer: "pasta",
        alternateAnswers: ["spaghetti"],
        photographer: "Engin Akyurt",
        photographerUrl: "https://www.pexels.com/@enginakyurt"
      },
      {
        url: "https://images.pexels.com/photos/1624487/pexels-photo-1624487.jpeg",
        answer: "taco",
        alternateAnswers: ["tacos"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1633525/pexels-photo-1633525.jpeg",
        answer: "pancakes",
        alternateAnswers: ["pancake stack"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  landmarks: {
    name: "Landmarks",
    icon: "🗽",
    images: [
      {
        url: "https://images.pexels.com/photos/699466/pexels-photo-699466.jpeg",
        answer: "eiffel tower",
        alternateAnswers: ["tour eiffel"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1603650/pexels-photo-1603650.jpeg",
        answer: "taj mahal",
        alternateAnswers: [],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2412606/pexels-photo-2412606.jpeg",
        answer: "great wall",
        alternateAnswers: ["great wall of china"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/290386/pexels-photo-290386.jpeg",
        answer: "statue of liberty",
        alternateAnswers: ["liberty statue"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/71241/pexels-photo-71241.jpeg",
        answer: "pyramids",
        alternateAnswers: ["pyramid"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg",
        answer: "big ben",
        alternateAnswers: ["clock tower"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1797161/pexels-photo-1797161.jpeg",
        answer: "colosseum",
        alternateAnswers: ["roman colosseum"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1797158/pexels-photo-1797158.jpeg",
        answer: "petra",
        alternateAnswers: ["treasury"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  nature: {
    name: "Nature",
    icon: "🌲",
    images: [
      {
        url: "https://images.pexels.com/photos/931007/pexels-photo-931007.jpeg",
        answer: "waterfall",
        alternateAnswers: ["falls"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1032650/pexels-photo-1032650.jpeg",
        answer: "beach",
        alternateAnswers: ["ocean beach"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg",
        answer: "mountain",
        alternateAnswers: ["mountains"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1834399/pexels-photo-1834399.jpeg",
        answer: "rainbow",
        alternateAnswers: ["rainbows"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1287075/pexels-photo-1287075.jpeg",
        answer: "volcano",
        alternateAnswers: ["volcanic mountain"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/3225517/pexels-photo-3225517.jpeg",
        answer: "northern lights",
        alternateAnswers: ["aurora borealis"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1001682/pexels-photo-1001682.jpeg",
        answer: "desert",
        alternateAnswers: ["sand dunes"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1295138/pexels-photo-1295138.jpeg",
        answer: "coral reef",
        alternateAnswers: ["reef"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  sports: {
    name: "Sports",
    icon: "⚽",
    images: [
      {
        url: "https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg",
        answer: "soccer field",
        alternateAnswers: ["football field", "soccer stadium", "football stadium"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/358042/pexels-photo-358042.jpeg",
        answer: "basketball court",
        alternateAnswers: ["basketball"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/209977/pexels-photo-209977.jpeg",
        answer: "tennis court",
        alternateAnswers: ["tennis"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2570139/pexels-photo-2570139.jpeg",
        answer: "baseball field",
        alternateAnswers: ["baseball stadium"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/46798/the-ball-stadion-football-the-pitch-46798.jpeg",
        answer: "hockey",
        alternateAnswers: ["ice hockey"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/54123/pexels-photo-54123.jpeg",
        answer: "swimming pool",
        alternateAnswers: ["pool"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/248547/pexels-photo-248547.jpeg",
        answer: "running track",
        alternateAnswers: ["track"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/4576723/pexels-photo-4576723.jpeg",
        answer: "volleyball",
        alternateAnswers: ["beach volleyball"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  vehicles: {
    name: "Vehicles",
    icon: "🚗",
    images: [
      {
        url: "https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg",
        answer: "sports car",
        alternateAnswers: ["ferrari", "race car"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2528118/pexels-photo-2528118.jpeg",
        answer: "train",
        alternateAnswers: ["locomotive"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1430676/pexels-photo-1430676.jpeg",
        answer: "helicopter",
        alternateAnswers: ["chopper"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1252841/pexels-photo-1252841.jpeg",
        answer: "airplane",
        alternateAnswers: ["plane", "jet"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/163236/luxury-yacht-boat-speed-water-163236.jpeg",
        answer: "yacht",
        alternateAnswers: ["boat", "sailboat"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2119103/pexels-photo-2119103.jpeg",
        answer: "motorcycle",
        alternateAnswers: ["bike"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1178448/pexels-photo-1178448.jpeg",
        answer: "submarine",
        alternateAnswers: ["sub"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1534411/pexels-photo-1534411.jpeg",
        answer: "hot air balloon",
        alternateAnswers: ["balloon"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  },
  instruments: {
    name: "Instruments",
    icon: "🎸",
    images: [
      {
        url: "https://images.pexels.com/photos/45243/saxophone-music-gold-gloss-45243.jpeg",
        answer: "saxophone",
        alternateAnswers: ["sax"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1021142/pexels-photo-1021142.jpeg",
        answer: "piano",
        alternateAnswers: ["grand piano"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/33597/guitar-classical-guitar-acoustic-guitar-electric-guitar.jpg",
        answer: "guitar",
        alternateAnswers: ["acoustic guitar"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1049690/pexels-photo-1049690.jpeg",
        answer: "drums",
        alternateAnswers: ["drum set"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1751731/pexels-photo-1751731.jpeg",
        answer: "violin",
        alternateAnswers: ["fiddle"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/2254140/pexels-photo-2254140.jpeg",
        answer: "trumpet",
        alternateAnswers: ["horn"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1904105/pexels-photo-1904105.jpeg",
        answer: "harp",
        alternateAnswers: ["classical harp"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      },
      {
        url: "https://images.pexels.com/photos/1407322/pexels-photo-1407322.jpeg",
        answer: "flute",
        alternateAnswers: ["silver flute"],
        photographer: "Pixabay",
        photographerUrl: "https://www.pexels.com/@pixabay"
      }
    ]
  }
};

export const getRandomImage = (categoryIds = null) => {
  try {
    let selectedCategory;

    if (categoryIds) {
      const categoryList = categoryIds.split(',');
      selectedCategory = imageDatabase[categoryList[Math.floor(Math.random() * categoryList.length)]];
    } else {
      const allCategories = Object.values(imageDatabase);
      selectedCategory = allCategories[Math.floor(Math.random() * allCategories.length)];
    }

    // Filter out already used images
    const availableImages = selectedCategory.images.filter(
      img => !usedImagesInCurrentGame.has(img.url)
    );

    if (availableImages.length === 0) {
      console.warn('No more unused images in category');
      return null;
    }

    const randomImage = availableImages[
      Math.floor(Math.random() * availableImages.length)
    ];

    // Mark this image as used
    usedImagesInCurrentGame.add(randomImage.url);

    return {
      ...randomImage,
      category: selectedCategory.name
    };
  } catch (error) {
    console.error('Error getting random image:', error);
    return null;
  }
};

export const backupImages = {
  animals: {
    lion: [
      {
        url: "https://images.pexels.com/photos/247502/pexels-photo-247502.jpeg",
        photographer: "Pexels",
        photographerUrl: "https://www.pexels.com"
      },
      // Add 2-3 more backup lion images
    ],
    tiger: [
      {
        url: "https://images.pexels.com/photos/145939/pexels-photo-145939.jpeg",
        photographer: "Pexels",
        photographerUrl: "https://www.pexels.com"
      },
      // Add 2-3 more backup tiger images
    ],
    // Add other animal backups...
  },
  landmarks: {
    "eiffel tower": [
      {
        url: "https://images.pexels.com/photos/699466/pexels-photo-699466.jpeg",
        photographer: "Pexels",
        photographerUrl: "https://www.pexels.com"
      },
      // Add 2-3 more backup Eiffel Tower images
    ],
    // Add other landmark backups...
  },
  // Add other categories...
}; 